var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('HeaderTop'),_c('MenuLeft'),_c('router-view'),_c('FooterAdmin'),_c('FooterButton')],1)}
var staticRenderFns = []

export { render, staticRenderFns }